import React, { useContext, useMemo } from "react"

import { TEEUP_SETTINGS_TYPES } from "@constants/teeups"
import { NewTeeupPageContext } from "@contexts/NewTeeupPageContext"
import { updateTeeup } from "@middlewares/backendMiddleware"
import { saveSettingsValue } from "@utils/teeupUtils"

import { Info, Organizers, SettingsRow, ButtonsPanel } from "../molecules"
import { Description } from "../newTeeupSettingsStyles"
import { Wrapper as RowWrapper, LeftSide, Title, ArrowIcon } from "./settingsRowStyles"

export const MainSettingsScreen = () => {
  const { teeup, isTeeupOrganiser, setIsShareTeeUpLinkModalOpen } =
    useContext(NewTeeupPageContext)
  const isShareLink = useMemo(() => teeup.settings?.enableSharedLink, [teeup])
  const isMute = useMemo(() => teeup?.isMute, [teeup])

  const handleShareLink = val => {
    saveSettingsValue({
      teeUpId: teeup.id,
      settings: teeup.settings,
      key: "enableSharedLink",
      val,
    })
  }

  const handleMuteTeeup = val => {
    updateTeeup({
      teeUpId: teeup.id,
      teeup: { isMute: val },
    })
  }

  return (
    <>
      <Info />

      <Organizers />

      {isTeeupOrganiser && (
        <div>
          <SettingsRow
            title="Participants Permissions"
            type={TEEUP_SETTINGS_TYPES.PERMISSIONS}
          />

          <SettingsRow
            isToggle
            title="Allow shared link"
            value={isShareLink}
            onToggle={handleShareLink}
          />
        </div>
      )}

      <Description>
        Only organizers have permission to edit participant settings.
      </Description>

      {/* TEEUP-INSIDE cleanup 2026-07-03: "Share link" ACTION (open the actual share/copy-link
          modal) moved out of the removed pill toolbar into the gear settings, per spec. The row
          above ("Allow shared link") only toggles whether sharing is enabled -- it never opened
          the modal itself, so this is a net-new reachable entry point, not a duplicate. */}
      <RowWrapper
        data-testid="shareLinkSettingsRow"
        onClick={() => setIsShareTeeUpLinkModalOpen(true)}>
        <LeftSide>
          <Title>Share link</Title>
        </LeftSide>
        <ArrowIcon name="arrow-2" color="var(--gray4)" />
      </RowWrapper>

      <SettingsRow
        isToggle
        title="Mute TeeUp"
        value={isMute}
        onToggle={handleMuteTeeup}
      />

      <Description>
        By muting the TeeUp, you will no longer receive notifications from this
        TeeUp to your phone
      </Description>

      <ButtonsPanel />
    </>
  )
}
